export default "__VITE_ASSET__UkGEv3tm__"